import { motion } from "framer-motion";
import {
  Gauge,
  SlidersHorizontal,
  TrendingUp,
  Headset,
  Scale,
  Workflow,
  BarChart3,
  Smartphone,
} from "lucide-react";
import { SectionHeading } from "./SectionHeading";
import { Icon3D } from "./Icon3D";

const items = [
  { icon: Gauge, title: "Base técnica para decisão", variant: "deepBlue" },
  { icon: SlidersHorizontal, title: "Controle operacional", variant: "vividBlue" },
  { icon: TrendingUp, title: "Sustentabilidade da carteira", variant: "aqua" },
  { icon: Headset, title: "Respaldo técnico em tempo real", variant: "vividBlue" },
  { icon: Scale, title: "Redução de subjetividade", variant: "deepBlue" },
  { icon: Workflow, title: "Apoio à decisão de CPT, aceitação e acompanhamento", variant: "aqua" },
  { icon: BarChart3, title: "Dashboard e indicadores de gestão", variant: "vividBlue" },
  { icon: Smartphone, title: "Experiência digital para beneficiários e operadoras", variant: "deepBlue" },
];

export const Differentials = () => {
  return (
    <section
      id="diferenciais"
      data-testid="differentials-section"
      className="relative py-20 md:py-28 bg-[#F6F8FB]"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <SectionHeading
          overline="Diferenciais"
          title="Por que escolher a"
          highlight="Previsa Saúde?"
          subtitle="Uma combinação única entre técnica, tecnologia e operação para apoiar suas decisões."
          testid="differentials-heading"
        />

        <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-4 gap-5">
          {items.map((it, idx) => (
            <motion.div
              key={it.title}
              data-testid={`differential-${idx}`}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-50px" }}
              transition={{
                duration: 0.5,
                ease: [0.16, 1, 0.3, 1],
                delay: idx * 0.04,
              }}
              whileHover={{ y: -4 }}
              className="group bg-white rounded-2xl border border-[#E5EAF2] p-6 hover:border-[#3787F5]/40 hover:shadow-[0_16px_40px_rgba(53,50,179,0.08)] transition-all duration-300"
            >
              <Icon3D
                icon={it.icon}
                variant={it.variant}
                size="md"
                className="mb-5 group-hover:scale-110 group-hover:-rotate-3"
              />
              <h3 className="text-[15px] font-bold text-[#1F2937] leading-snug">
                {it.title}
              </h3>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
